
define('modules/application/wizard/steps/zoneStep/complexZoneStep/zoneCollection',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../zoneCollection",
  "./zoneModel"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneCollection,
  ZoneModel) {

  var complexZoneStepZoneCollection = ZoneCollection.extend({
    addConstructors                       : function()  {
      ZoneCollection.prototype.addConstructors.apply(this);
      this.ZoneModel = ZoneModel;
    },
    initialize                            : function()  {
      this.addConstructors();
      this.stepEventAggregator = arguments[1].stepEventAggregator;

      this.unbind("add",                                            this.addedElementEventHandler);
      this.bind("add",                                              this.addedElementEventHandler, this);

      this.unbind("remove",                                         this.removedElementEventHandler);
      this.bind("remove",                                           this.removedElementEventHandler, this);

      this.stepEventAggregator.unbind("zone:loaded",                this.requestZoneRevalidation);
      this.stepEventAggregator.bind("zone:loaded",                  this.requestZoneRevalidation, this);

    },
    checkZonesStatus                      : function()  {
      var validCollection = true;
      var filterId = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");
      var i=0;

      if (filterId)
      {
        if ( (filterId===-1) || (filterId===1) || (filterId===2))
          return true;
        else
        {
          for (i=0;i<this.models.length;i++)
          if (!this.models[i].isValid())
          {
            validCollection = false;
            break;
          }
        }
      }
      else
      {
        for (i=0;i<this.models.length;i++)
          if (!this.models[i].isValid())
          {
            validCollection = false;
            break;
          }
      }
      return validCollection;
    },
    requestZoneRevalidation               : function() {
      for (var i=0;i<this.models.length;i++)
        this.models[i].updateZoneValidity();
    }
  });

  // Required, return the module for AMD compliance
  return complexZoneStepZoneCollection;

});